(function () {
  var hasFinePointer = window.matchMedia('(pointer: fine)').matches;

  function initLgFeaturedCollections() {
    document.querySelectorAll('.lg-featured-collection').forEach(async function (el) {
      var handle = el.dataset.collection;
      if (!handle) return;

      var limit = parseInt(el.dataset.limit, 10) || 4;
      var columns = parseInt(el.dataset.columns, 10) || 4;

      try {
        var res = await fetch('/collections/' + handle);
        var html = await res.text();

        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll(
          '.shopify-section--main-collection product-list.product-list product-card.product-card'
        );

        if (!cards.length) {
          console.warn('LG Featured Collection : aucune carte trouvée pour', handle);
          return;
        }

        var selectedCards = Array.from(cards).slice(0, limit);

        selectedCards.forEach(function (card) {
          card.removeAttribute('reveal-on-scroll');

          // Images secondaires : retirées du DOM sur mobile (anti-hover tactile)
          if (!hasFinePointer) {
            card.querySelectorAll('.product-card__image--secondary').forEach(function (img) {
              img.remove();
            });
          }

          // Nettoyage des attributs image
          card.querySelectorAll('img.product-card__image').forEach(function (img) {
            img.removeAttribute('width');
            img.removeAttribute('height');
            img.removeAttribute('fetchpriority');
            img.setAttribute('loading', 'lazy');
          });

          // Retrait des éléments non désirés
          card.querySelectorAll('.rating-badge, [class*="rating"]').forEach(function (r) { r.remove(); });
          card.querySelectorAll('fieldset, .color-swatch, [class*="swatch"]').forEach(function (s) { s.remove(); });
          card.querySelectorAll('.smallcaps.text-subdued').forEach(function (c) { c.remove(); });
          card.querySelectorAll('.badge-list').forEach(function (b) { b.remove(); });
          card.querySelectorAll('quick-buy-modal').forEach(function (m) { m.remove(); });
          card.querySelectorAll('[aria-controls^="product-quick-buy"]').forEach(function (b) { b.remove(); });
          card.querySelectorAll('product-form').forEach(function (f) { f.remove(); });
          card.querySelectorAll('.vendor, [class*="vendor"]').forEach(function (v) { v.remove(); });
        });

        // Construction du composant
        var section = document.createElement('div');
        section.className = 'lg-featured-collection-section';

        var container = document.createElement('div');
        container.className = 'container';

        // Sous-titre automatique
        var collectionTitle = doc.querySelector('h1')?.textContent?.trim() || handle;
        var subheadingText = el.dataset.subheading;

        if (subheadingText === undefined) {
          subheadingText = 'Découvre la collection ' + collectionTitle;
        }

        if (subheadingText) {
          var subheading = document.createElement('p');
          subheading.className = 'lg-featured-collection-section__subheading';
          subheading.textContent = subheadingText;
          container.appendChild(subheading);
        }

        // Liste de produits
        var wrapper = document.createElement('div');
        wrapper.className = 'lg-featured-collection-wrapper';
        wrapper.style.setProperty('--product-list-items-per-row', columns);

        var list = document.createElement('product-list');
        list.className = 'product-list product-list--compact justify-center';

        selectedCards.forEach(function (card) {
          list.appendChild(card);
        });

        wrapper.appendChild(list);
        container.appendChild(wrapper);

        // Bouton automatique vers la collection
        var buttonText = el.dataset.buttonText;
        if (buttonText === undefined) {
          buttonText = 'Découvrir la collection';
        }

        if (buttonText) {
          var buttonWrap = document.createElement('p');
          buttonWrap.className = 'lg-featured-collection-section__button-wrap';

          var button = document.createElement('a');
          button.className = 'button button--outline';
          button.href = '/collections/' + handle;
          button.textContent = buttonText;

          buttonWrap.appendChild(button);
          container.appendChild(buttonWrap);
        }

        section.appendChild(container);
        el.replaceWith(section);
      } catch (e) {
        console.error('LG Featured Collection error:', e);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLgFeaturedCollections);
  } else {
    initLgFeaturedCollections();
  }
})();